import ShareableLinkSendPassword from './ShareableLinkSendPassword.component';

export default ShareableLinkSendPassword;
